import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';


export const ContactPreferencesToggleListHeader = withConfig(theme => styled('h4', { label: 'ContactPreferencesToggleListHeader' })`
    font-size: ${theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.5;
    margin: 0 0 8px 0;
`);

export const ContactPreferencesToggleListSubHeader = withConfig(theme => styled('p', { label: 'ContactPreferencesToggleListSubHeader' })`
    font-size: ${theme.star.fontSize.small};
    line-height: 1.3333;
    margin: 0;
`);

export const ContactPreferencesToggleListContentContainer = styled('section', { label: 'ContactPreferencesToggleListContentContainer' })`
    display: flex;
    margin-top: 16px;
    gap: 16px;
    flex-direction: column;
    text-align: start;
`;

export const ContactPreferencesToggleListContentRowContainer = styled('div', { label: 'ContactPreferencesToggleListContentRowContainer' })`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

interface ContactPreferencesToggleListContentRowsContainerPropsType {
    systemPagesVariant: DefaultComponentVariantType | null;
    additionalContainer: boolean;
}


export const ContactPreferencesToggleListContentRowsContainer = withConfig(theme => styled('div', { label: 'ContactPreferencesToggleListContentRowsContainer' })<ContactPreferencesToggleListContentRowsContainerPropsType>`
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-radius: ${({ systemPagesVariant }): string => systemPagesVariant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.small : '0'};

    ${({ additionalContainer }):string => additionalContainer === true ? `
        padding: 16px;
        background-color: ${theme.star.blockingPopUp.bgColor};
    `: ''}
`);

export const ContactPreferencesToggleListContentRow = styled('div', { label: 'ContactPreferencesToggleListContentRow' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-transform: capitalize;
`;

export const ContactPreferencesToggleListContentRowText = withConfig(theme => styled('span', { label: 'ContactPreferencesToggleListContentRowText' })`
    font-size: ${theme.star.fontSize.xRegular};
    line-height: 1.4286;
`);

export const ContactPreferencesToggleListContentHeader = withConfig(theme => styled('h5', { label: 'ContactPreferencesToggleListContentHeader' })`
    font-size: ${theme.star.fontSize.xRegular};
    line-height: 1.4286;
    margin: 0;
`);

export const ContactPreferencesToggleListContentText = withConfig(theme => styled('span', { label: 'ContactPreferencesToggleListContentText' })`
    font-size: ${theme.star.fontSize.xRegular};
    line-height: 1.4286;
`);
